import { debounce } from 'lodash';
import { api, checkForUnauthorized } from '@/utils';

export default {
  name: 'ProductOverviewTable',
  components: {},
  props: {
    search: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    headers: [
      { text: 'Code', value: 'id' },
      { text: 'Name', value: 'name' },
      { text: 'Imo Class', value: 'imoClass' },
      { text: 'Un Number', value: 'unNumber' },
      { text: '', value: 'buttons' },
    ],
    products: [],
    loading: true,
    pageSize: 14,
    page: 1,
    apiVersion: 1,
    showConfirm: false,
    itemIdToDelete: '',
  }),
  computed: {},
  methods: {
    fetchProducts() {
      this.loading = true;

      // BASEURL
      let url = '/products?';

      if (this.search !== '') {
        url += `code=${this.search}`;
      }

      api.get(url)
        .then((response) => {
          this.products = response.data;
          this.loading = false;
        })
        .catch((error) => {
          checkForUnauthorized(error);
          console.log('something went wrong while getting products', error);
        });
    },
    goToDetail(item) {
      this.$router.push({ name: 'product-with-id', params: { id: item.id } });
    },
    setConfirm(item) {
      this.itemIdToDelete = item.id;
      this.showConfirm = true;
    },
    cancelConfirm() {
      this.itemIdToDelete = '';
      this.showConfirm = false;
    },
    deleteProduct() {
      if (this.itemIdToDelete !== '') {
        // BASEURL
        const url = `/products/${this.itemIdToDelete}`;

        api.delete(url)
          .then(() => {
            this.fetchProducts();
            this.itemIdToDelete = '';
            this.showConfirm = false;
          })
          .catch((error) => {
            console.log('something went wrong while deleting product', error);
          });
      }
    },
    debounceSearch: debounce(function fetchProducts() {
      this.fetchProducts();
    }, 300),
  },
  watch: {
    search() {
      this.debounceSearch();
    },
  },
  mounted() {
    this.fetchProducts();
  },
};
